export const GET_ACCOUNTS_SUCCESS = "getAccountsSuccess"
export const CREATE_ACCOUNT_SUCCESS = "createAccountSuccess"
export const UPDATE_ACCOUNT_SUCCESS = "updateAccountSuccess"
export const SET_LOADER = "setLoader"
export const DELETE_ACCOUNT_SUCCESS = "deleteAccountSuccess"